module.exports = __webpack_public_path__ + "img/date.e2a9c85f.svg";